import { canNativeShare, type ShareOutcome } from "@wags/ui/share-or-copy.ts";
import { cn } from "@wags/ui/ui-utils";
import { VercelImage } from "@wags/ui/vercel-image.tsx";
import { useState } from "react";

export function ShareOfferMessage({
    text,
    photoUrl,
    onShare,
    onClose,
    onExpire,
}: {
    text: string;
    photoUrl: string | undefined;
    onShare: () => Promise<ShareOutcome>;
    onClose: () => void;
    onExpire: () => void;
}) {
    const [isSharing, setIsSharing] = useState(false);

    return (
        <output
            className={cn(
                "pointer-events-auto flex animate-share-offer-life items-center gap-4 rounded-nested border border-doberman-black/[0.06] bg-true-white py-3.5 pr-5 shadow-elevation-md",
                photoUrl ? "pl-3.5" : "pl-5",
            )}
            data-sharing={isSharing ? "" : undefined}
            onAnimationEnd={(event) => {
                if (event.target !== event.currentTarget) return;
                onExpire();
            }}
        >
            {photoUrl && (
                <span
                    aria-hidden="true"
                    className="-my-1.5 shrink-0 -rotate-6 animate-share-offer-sticker share-offer-sticker-rim rounded-nested bg-true-white p-0.5"
                >
                    <VercelImage
                        src={photoUrl}
                        alt=""
                        width={32}
                        height={32}
                        loading="eager"
                        listingMedia
                        className="block size-8 rounded-label object-cover"
                    />
                </span>
            )}
            <p className="min-w-0 flex-1 truncate text-body text-doberman-black">
                {text}
            </p>
            <button
                type="button"
                onClick={() => {
                    setIsSharing(true);
                    void onShare().then(
                        (outcome) => {
                            if (outcome.status === "completed") onClose();
                            else setIsSharing(false);
                        },
                        () => setIsSharing(false),
                    );
                }}
                className="-mx-2 -my-3 inline-flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-nested px-2 text-label text-doberman-black transition-colors hover:text-doberman-black/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-labrador-yellow"
            >
                {canNativeShare() ? "Share" : "Copy link"}
            </button>
        </output>
    );
}
